import { Reveal, Eyebrow } from "./Motion";
import { CTA } from "./CTA";

export const CTABand = ({ eyebrow = "Begin the conversation", title = "Let's simplify HR. Together.", text, cta = "Talk to Krimzon", to = "/contact" }) => (
  <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36" data-testid="cta-band">
    <Reveal>
      <div className="relative grid gap-10 border-t border-[#D4AF37] pt-14 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className="font-display mt-6 text-3xl font-bold tracking-tight text-[#0D9488] sm:text-5xl lg:text-6xl">{title}</h2>
          {text && <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#2D6A64] md:text-lg">{text}</p>}
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <CTA to={to} testId="cta-band-button">{cta}</CTA>
        </div>
      </div>
    </Reveal>
  </section>
);
